import { LowerCasePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
@Component({
    selector: 'multisite-flag',
    templateUrl: './multisite-flag.component.html',
    styleUrls: ['./multisite-flag.component.scss'],
    standalone: true,
    imports: [NgClass, LowerCasePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultisiteFlagComponent {
    @Input({
        required: true
    })
    siteId!: string;
    @Input()
    simpleMultisite: boolean = false;
    @Input()
    dropDownFlag: boolean = false;
}
